import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const arrow_right_small: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <path fill="none" stroke={iconColor} d="M5,12.5 L17.5,12.5 M13.5,16.5 L17.5,12.5 L13.5,8.5" />
    </svg>
  );
};
